import type { EnvironmentConfig } from './types';
import { STORAGE_KEYS } from './utils';

function safeParse<T>(raw: string | null, fallback: T): T {
  if (!raw) return fallback;
  try {
    return JSON.parse(raw) as T;
  } catch {
    return fallback;
  }
}

function isLocalEnvironment(value: unknown): value is EnvironmentConfig {
  return (
    typeof value === 'object' &&
    value !== null &&
    typeof (value as EnvironmentConfig).id === 'string' &&
    typeof (value as EnvironmentConfig).name === 'string' &&
    typeof (value as EnvironmentConfig).baseUrl === 'string' &&
    ((value as EnvironmentConfig).source ?? 'local') === 'local'
  );
}

export function loadLocalEnvironments(): EnvironmentConfig[] {
  if (typeof localStorage === 'undefined') return [];
  const list = safeParse<unknown[]>(localStorage.getItem(STORAGE_KEYS.localEnvironments), []);
  if (!Array.isArray(list)) return [];
  return list.filter(isLocalEnvironment);
}

export function saveLocalEnvironments(list: EnvironmentConfig[]): void {
  if (typeof localStorage === 'undefined') return;
  try {
    localStorage.setItem(STORAGE_KEYS.localEnvironments, JSON.stringify(list));
  } catch (error) {
    console.warn('[ER-Console] 保存本地环境失败:', error);
  }
}

export function loadApiKeys(): Record<string, string> {
  if (typeof localStorage === 'undefined') return {};
  const map = safeParse<unknown>(localStorage.getItem(STORAGE_KEYS.apiKeys), {});
  if (typeof map !== 'object' || map === null) return {};
  return map as Record<string, string>;
}

export function saveApiKeys(map: Record<string, string>): void {
  if (typeof localStorage === 'undefined') return;
  try {
    localStorage.setItem(STORAGE_KEYS.apiKeys, JSON.stringify(map));
  } catch (error) {
    console.warn('[ER-Console] 保存 API Key 失败:', error);
  }
}

export function loadActiveId(): string | null {
  if (typeof localStorage === 'undefined') return null;
  return localStorage.getItem(STORAGE_KEYS.activeId);
}

export function saveActiveId(id: string | null): void {
  if (typeof localStorage === 'undefined') return;
  try {
    if (id) localStorage.setItem(STORAGE_KEYS.activeId, id);
    else localStorage.removeItem(STORAGE_KEYS.activeId);
  } catch (error) {
    console.warn('[ER-Console] 保存当前环境失败:', error);
  }
}